/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define([], function() {

    function errorHandler(reason) {
        var contentType = reason.headers && reason.headers.get('content-type');
        if (reason.json) {
            if (/application\/json.*/.test(contentType)) {
                reason.json().then(this.fail).catch(this.fail);
            } else {
                reason.text().then(this.fail).catch(this.fail);
            }
        } else {
            this.fail(reason);
        }
    }

    return function(options, reason) {
        var errHandler = errorHandler.bind(options);
        if (options.fail) {
            errHandler(reason);
        }
    };
});



// WEBPACK FOOTER //
// ./requester/errorHandlerFetch.js